import { useState } from 'react';

const testimonials = [
  {
    quote:
      'Die Qualität und Präzision der Natursteine hat unsere Erwartungen weit übertroffen. Unser Vorgarten sieht traumhaft aus und ist absolut pflegeleicht.',
    name: 'Michael Weber',
    location: 'Hamburg',
    rating: 5,
    initial: 'M',
  },
  {
    quote:
      'Hervorragende Beratung und top Qualität! Die Auswahl an Steinarten ist riesig — wir haben genau das Richtige für unsere Gabionen-Wand gefunden.',
    name: 'Sandra Hoffmann',
    location: 'Rostock',
    rating: 5,
    initial: 'S',
  },
  {
    quote:
      'Wir haben schon vor Jahren bei Ziersteine.de bestellt und kommen immer wieder gerne zurück. Zuverlässiger Service, faire Preise, tolle Produkte.',
    name: 'Thomas Krause',
    location: 'Berlin',
    rating: 5,
    initial: 'T',
  },
  {
    quote:
      'Der Edelsplitt hat unserem Garten eine ganz neue Dimension gegeben. Seitdem brauchen wir kaum noch Unkraut zu jäten — wirklich eine super Investition!',
    name: 'Petra Lange',
    location: 'München',
    rating: 5,
    initial: 'P',
  },
  {
    quote:
      'Von der Beratung über die Lieferung bis hin zur Qualität der Steine — alles hat gestimmt. Absolute Empfehlung für alle, die ihren Garten aufwerten wollen.',
    name: 'Klaus Brandt',
    location: 'Stuttgart',
    rating: 5,
    initial: 'K',
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  const t = testimonials[current];

  return (
    <section id="testimonials" className="py-32 px-6" style={{ backgroundColor: '#F5F5F7' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Big Quote */}
          <div>
            <div className="flex items-center gap-2 mb-8">
              <span className="w-1.5 h-1.5 rounded-full bg-stone-400" />
              <span className="text-stone-500 text-sm tracking-widest uppercase">Kundenstimmen</span>
            </div>

            <div
              className="text-stone-300 leading-none mb-4 select-none"
              style={{ fontSize: '8rem', fontFamily: "'Playfair Display', serif", lineHeight: 1 }}
            >
              "
            </div>

            <blockquote
              className="text-stone-900 leading-snug font-light mb-8"
              style={{ fontSize: 'clamp(1.2rem, 2.5vw, 1.8rem)', fontFamily: "'Playfair Display', serif" }}
            >
              {t.quote}
            </blockquote>

            <div className="flex items-center justify-between">
              <div>
                <div className="flex gap-0.5 mb-2">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                  ))}
                </div>
                <p className="font-semibold text-stone-900 text-sm">{t.name}</p>
                <p className="text-stone-500 text-xs mt-0.5 flex items-center gap-1">
                  <i className="ri-map-pin-line text-xs" />
                  {t.location} · Google Bewertung
                </p>
              </div>

              {/* Navigation */}
              <div className="flex items-center gap-3">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-stone-300 hover:bg-stone-900 hover:border-stone-900 hover:text-white text-stone-700 transition-all cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-sm" />
                </button>
                <span className="text-stone-400 text-xs">
                  {current + 1} / {total}
                </span>
                <button
                  onClick={next}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-stone-300 hover:bg-stone-900 hover:border-stone-900 hover:text-white text-stone-700 transition-all cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-sm" />
                </button>
              </div>
            </div>
          </div>

          {/* Right: Cards */}
          <div className="flex flex-col gap-4">
            {testimonials.map((item, i) => (
              <div
                key={item.name}
                onClick={() => setCurrent(i)}
                className={`p-5 rounded-2xl cursor-pointer transition-all duration-300 ${
                  i === current
                    ? 'bg-stone-900 text-white shadow-lg'
                    : 'bg-white text-stone-700 hover:bg-stone-100'
                }`}
              >
                <div className="flex items-start gap-4">
                  <div
                    className={`w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full text-sm font-semibold ${
                      i === current ? 'bg-white/20 text-white' : 'bg-stone-100 text-stone-700'
                    }`}
                  >
                    {item.initial}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <p className={`font-medium text-sm ${i === current ? 'text-white' : 'text-stone-900'}`}>
                        {item.name}
                      </p>
                      <div className="flex gap-0.5">
                        {Array.from({ length: item.rating }).map((_, j) => (
                          <i key={j} className="ri-star-fill text-amber-400 text-xs" />
                        ))}
                      </div>
                    </div>
                    <p className={`text-xs leading-relaxed line-clamp-2 ${i === current ? 'text-stone-300' : 'text-stone-500'}`}>
                      {item.quote}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
